export { default } from './hero-slant';
